var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMlWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-4 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10919",
    "data-name": "Group 10919",
    transform: "translate(18516.5 1317.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10918",
    "data-name": "Group 10918",
    transform: "translate(-18516 -1317)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1830",
    "data-name": "Ellipse 1830",
    className: "cls-1",
    cx: 1.401,
    cy: 1.419,
    rx: 1.401,
    ry: 1.419,
    transform: "translate(7.785 6.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7162",
    "data-name": "Path 7162",
    className: "cls-2",
    d: "M22.889,8.459A4.333,4.333,0,0,1,21.2,5.013a4.257,4.257,0,1,1,8.514,0,4.369,4.369,0,0,1-1.689,3.446",
    transform: "translate(-16.219 -0.7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10173",
    "data-name": "Group 10173",
    transform: "translate(0 9.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7163",
    "data-name": "Path 7163",
    className: "cls-3",
    d: "M53.573,1.784A9.067,9.067,0,0,1,57.192,3.9",
    transform: "translate(-41.708 -1.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7164",
    "data-name": "Path 7164",
    className: "cls-4",
    d: "M6.625,0A9.321,9.321,0,0,1,0,8.945",
    transform: "translate(6.625 8.945) rotate(180)"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1064",
    "data-name": "Line 1064",
    className: "cls-4",
    x2: 9.032,
    transform: "translate(-18505.033 -1302.161)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1065",
    "data-name": "Line 1065",
    className: "cls-4",
    x2: 9.032,
    transform: "translate(-18505.033 -1299.581)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1066",
    "data-name": "Line 1066",
    className: "cls-4",
    x2: 9.032,
    transform: "translate(-18505.033 -1297)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlWhite);
export default __webpack_public_path__ + "static/media/mlWhite.ec104af1bcb7171b3396f936d778ccb2.svg";
export { ForwardRef as ReactComponent };